import {
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarExport,
  GridToolbarFilterButton,
} from '@material-ui/data-grid';
import React from 'react';
import Box from '@material-ui/core/Box';
import { ExpandMore, PictureAsPdfSharp, Search, Tune } from '@material-ui/icons';
import { printDocument } from '../../../../actions/utils';
import { FormattedMessage } from 'react-intl';
import InputAdornment from '@material-ui/core/InputAdornment';
import { createStyles, TextField } from '@material-ui/core';
import makeStyles from '@material-ui/core/styles/makeStyles';
import {
  ALMOST_BLACK_COLOR,
  CUSTOM_BORDER,
  PRIMARY_COLOR,
} from '../../../../const/color-const';
import { lighten } from '@material-ui/core/styles';

const DownloadPdfButton = (printRef) => {
  return (
    <Box onClick={() => printDocument(printRef)} className="download-PDF">
      <PictureAsPdfSharp />
      <span> <FormattedMessage
        id="report.toolbar.download"
        defaultMessage="DOWNLOAD"
      /></span>
    </Box>
  );
};

const useStyles = makeStyles((theme) =>
  createStyles({
    toolbarBox: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%',
      background: theme.palette.primary.main,
      borderBottom: '1px solid rgba(0, 0, 0, 0.25)',
      borderTopRightRadius: 8,
      borderTopLeftRadius: 8,
      padding: theme.spacing(0, 1, 0, 0.5),
    },
    textField: {
      height: 36,
      margin: theme.spacing(1, 0, 1, 0.5),
      maxWidth: 260,
      width: '100%',
      '& [class*="MuiInputBase-formControl"]': {
        background: lighten(PRIMARY_COLOR, 0.28),
        paddingLeft: theme.spacing(1.5),
        height: '100%',
        color: 'black',
        '& fieldset': {
          boxShadow: '0px 0px 8px 3px rgba(0,0,0,0.10)',
          border: 'none',
        },
        '& svg': {
          fill: CUSTOM_BORDER,
        },
        '&.Mui-focused': {
          '& fieldset': {
            border: `1px solid ${CUSTOM_BORDER}`,
          },
          '& svg': {
            fill: ALMOST_BLACK_COLOR,
          },
        },
      },
    },
  }),
);

export const DefaultToolbar = ({ printRef, search, handleSearchChange, includeSearch }) => {
  const classes = useStyles();
  
  return (
    <Box className={classes.toolbarBox}>
      <GridToolbarContainer>
        <GridToolbarColumnsButton endIcon={<ExpandMore />} />
        <GridToolbarFilterButton componentsProps={{
          button: {
            startIcon: <Tune />,
            endIcon: <ExpandMore />,
          },
        }} />
        <GridToolbarDensitySelector endIcon={<ExpandMore />} />
        <GridToolbarExport endIcon={<ExpandMore />} />
        {printRef?.current && <DownloadPdfButton printRef={printRef} />}
      </GridToolbarContainer>
      
      {includeSearch && <TextField
        className={classes.textField}
        value={search}
        onChange={handleSearchChange}
        placeholder="Search..."
        variant="outlined"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Search />
            </InputAdornment>
          ),
        }}
      />}
    </Box>
  );
};